var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "caption" },
    [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.generateMessage("attachements.customerPlatform")) +
            " :\n  "
        )
      ]),
      _vm._v(" "),
      _vm.items.length
        ? _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                top: "",
                "close-on-content-click": false
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function({ on }) {
                      return [
                        _c(
                          "div",
                          _vm._g({ staticClass: "mouse" }, on),
                          [
                            _c("v-icon", [
                              _vm._v(
                                _vm._s(_vm.generateMessage("attachements.icon"))
                              )
                            ]),
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.generatePluralizedMessage(
                                    "attachements.documentsFound",
                                    _vm.items.length
                                  )
                                ) +
                                "\n      "
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                2457585569
              )
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _vm.items.length
                    ? _c(
                        "v-list",
                        _vm._l(_vm.items, function(item) {
                          return _c(
                            "v-list-item",
                            {
                              key: item.uid,
                              on: {
                                click: function($event) {
                                  return _vm.download(item)
                                }
                              }
                            },
                            [
                              _vm.downloading === item.id
                                ? _c(
                                    "v-list-item-title",
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          size: "20",
                                          width: "2",
                                          color: "light-blue"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c("v-list-item-title", [
                                    _vm._v(_vm._s(item.title))
                                  ])
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.isLoading
                    ? _vm.generateMessage("attachements.loading")
                    : _vm.generateMessage("attachements.noItems")
                ) +
                "\n  "
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }